export class GrupoProdutoModel {
  id: number;
  descricao: String;
}



// WEBPACK FOOTER //
// /app/src/app/model/produto/grupo-produto.model.ts